module.exports = __webpack_public_path__ + "img/ic_questions_technic_selected.afe718e7.svg";